import React from "react";
import { DOCTOR_CALLOUT, GUARANTEE, TESTIMONIALS } from "../../lib/resultsCopy";

const GOLD_CARD = "rounded-[1.5rem] border-[1.5px] border-[#D4AF35] bg-[#14120A]";

export const DoctorCallout = () => (
  <div className={`${GOLD_CARD} p-6 md:p-8 my-7`} data-testid="doctor-callout">
    <p className="font-display font-bold uppercase tracking-tight text-base md:text-lg text-white leading-snug">
      {DOCTOR_CALLOUT.lead}
    </p>
    <ul className="mt-4 space-y-1.5 font-display font-bold uppercase tracking-tight text-base md:text-lg text-white">
      {DOCTOR_CALLOUT.items.map((t) => (
        <li key={t} className="flex gap-3">
          <span className="text-[#D4AF35]" aria-hidden="true">&bull;</span>
          {t}
        </li>
      ))}
    </ul>
    <p className="mt-5 font-display font-black uppercase tracking-tight text-xl md:text-2xl text-[#D4AF35] leading-tight">
      {DOCTOR_CALLOUT.punch}
    </p>
  </div>
);

export const Guarantee = () => (
  <section className="w-[90%] max-w-[760px] mx-auto mt-20" data-testid="guarantee">
    <div className={`${GOLD_CARD} p-7 md:p-10`}>
      <p className="text-[12px] font-bold tracking-[0.18em] uppercase text-[#D4AF35]">{GUARANTEE.label}</p>
      <h2 className="mt-3 font-display font-black uppercase tracking-tighter text-3xl md:text-4xl text-white leading-tight">
        {GUARANTEE.heading}
      </h2>
      <div className="mt-6 space-y-5 text-lg text-white/75 leading-relaxed font-medium">
        <p>{GUARANTEE.intro}</p>
        {GUARANTEE.items.map((it) => (
          <p key={it.label}>
            <strong className="font-bold uppercase text-[#D4AF35]">{it.label}</strong> {it.text}
          </p>
        ))}
      </div>
    </div>
  </section>
);

export const Testimonials = () => (
  <section className="w-[90%] max-w-[760px] mx-auto mt-20 space-y-8" data-testid="testimonials">
    {TESTIMONIALS.map((t) => (
      <blockquote key={t.by} className="border-l-[3px] border-[#D4AF35] pl-5 md:pl-6">
        <p className="text-lg md:text-xl text-white italic leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
        <footer className="mt-3 text-[12px] font-bold tracking-[0.18em] uppercase text-[#D4AF35]">{t.by}</footer>
      </blockquote>
    ))}
  </section>
);
